export default __webpack_public_path__ + "static/media/nwokolo.331532c0.png";